export type WithLocalId<T> = T & { localId: string };

export const getLocalIdFromGqlId = (id: string): string => {
    return id?.split("|")?.pop();
};
